"use strict";
var select_1 = require('./select/select');
exports.SELECT_DIRECTIVES = [select_1.SelectComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-select/components/select.js
 ** module id = 1046
 ** module chunks = 0
 **/